import * as Yup from "yup";
import getLangData from "../../../../utils/getLangData";

const schema = intl => {

  const REQUIRED_FIELD = intl.formatMessage({
    id: "AUTH.VALIDATION.getLangData().fields.required"
  })

  const INVALID_FIELD = intl.formatMessage({
    id: "AUTH.VALIDATION.INVALID_FIELD"
  })

  return (Yup.object().shape({
    firstName: Yup.string().required(
      getLangData().fields.required
    ),
    lastName: Yup.string().required(
      getLangData().fields.required
    ),
    email: Yup.string()
      .email(
        INVALID_FIELD
      )
      .required(
        getLangData().fields.required
      ),
    password: Yup.string().required(
      getLangData().fields.required
    ),
    address: Yup.string().required(
      getLangData().fields.required
    ),
    phone: Yup.number().required(
      getLangData().fields.required
    ),
    supplierBIO: Yup.string(),
    businessType: Yup.array()
      .of(Yup.string().oneOf(["0", "1"]))
      .required(
        getLangData().fields.required
      ),
    country: Yup.string().required(
      getLangData().fields.required
    ),
    city: Yup.string().required(
      getLangData().fields.required
    ),
    province: Yup.string().required(getLangData().fields.required),
    zipCode: Yup.number().required(getLangData().fields.required),
    supplierCID: Yup.string().required(getLangData().fields.required),
     onlineStore: Yup.bool()
      .required(getLangData().fields.required),
    offlineStore: Yup.bool()
      .required(getLangData().fields.required),
    contactPerson: Yup.string(),
    contactPersonTitle: Yup.string(),
    contactPersonPhone: Yup.number(),
    contactPersonEmail: Yup.string()
  }))
}

export default schema;
